import React, { useContext } from 'react';
import AppContext from '../../contexts/AppContext';
import htmlParse from 'react-html-parser';
import { isMobile, isTablet, isIOS } from 'react-device-detect';

import './About.css';

export default function About() {
  const { dictionnary, axl } = useContext(AppContext);

  const onClickLinkHandler = (url) => {
    if (axl) {
      const AxL = require('../../utils/Axl').default;
      axl.sendMessage(AxL.ChildToHost.NAVIGATE, url);

      return;
    } else {
      console.log('no axl');
    }
  };

  const aboutDescr =
    isMobile || isTablet
      ? htmlParse(dictionnary.get('about-descr-mobile'))
      : htmlParse(dictionnary.get('about-descr'));

  return (
    <>
      <img
        alt={'about-un'}
        id={'image-un'}
        src={
          'street-gallery/assets/curated/a6e202ae-6a2d-4552-a3a3-60f639fa04f7.jpg'
        }
        width="1057"
        height="752"
      ></img>
      {aboutDescr}
      <br />

      {!isIOS && (
        <>
          <button
            type="button"
            className="btn-link"
            onClick={(e) => {
              onClickLinkHandler(dictionnary.get('about-un-link'));
              e.preventDefault();
            }}
          >
            {dictionnary.get('about-un-link-learn')}
          </button>
          <br />
          <button
            type="button"
            className="btn-link"
            onClick={(e) => {
              onClickLinkHandler(dictionnary.get('future-link'));
              e.preventDefault();
            }}
          >
            {dictionnary.get('future-link-learn')}
          </button>
          <br />
          <button
            type="button"
            className="btn-link"
            onClick={(e) => {
              onClickLinkHandler(dictionnary.get('agora-link'));
              e.preventDefault();
            }}
          >
            {dictionnary.get('agora-link-learn')}
          </button>

          {false && (
            <>
              <br />
              <br />
              <button
                type="button"
                className="btn-link"
                onClick={(e) => {
                  onClickLinkHandler(dictionnary.get('common-privacy-link'));
                  e.preventDefault();
                }}
              >
                {dictionnary.get('common-privacy')}
              </button>
            </>
          )}
        </>
      )}

      {!isMobile && !isTablet && (
        <>
          <br />
          <br />
          {htmlParse(dictionnary.get('about-sharing'))} <br />
          <br />
        </>
      )}
    </>
  );
}
